import React from 'react';
import { Linkedin, Twitter, Instagram, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_knowledge-hub-196/artifacts/464mphrk_Recurso%2026LOGO%20def.png"
              alt="Urpe School"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              La escuela de negocios para emprendedores que quieren construir empresas que escalan.
              Aprende de emprendedores reales, no de profesores.
            </p>
            {/* Social links */}
            <div className="flex space-x-4">
              <a
                href="#"
                className="p-2 bg-white/5 border border-white/10 rounded-lg hover:bg-teal-500/10 hover:border-teal-500/30 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} className="text-gray-400 hover:text-teal-400" />
              </a>
              <a
                href="#"
                className="p-2 bg-white/5 border border-white/10 rounded-lg hover:bg-teal-500/10 hover:border-teal-500/30 transition-all duration-300"
                aria-label="Twitter"
              >
                <Twitter size={18} className="text-gray-400 hover:text-teal-400" />
              </a>
              <a
                href="#"
                className="p-2 bg-white/5 border border-white/10 rounded-lg hover:bg-teal-500/10 hover:border-teal-500/30 transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={18} className="text-gray-400 hover:text-teal-400" />
              </a>
              <a
                href="#"
                className="p-2 bg-white/5 border border-white/10 rounded-lg hover:bg-teal-500/10 hover:border-teal-500/30 transition-all duration-300"
                aria-label="Email"
              >
                <Mail size={18} className="text-gray-400 hover:text-teal-400" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#hero" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#curriculum" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Programa
                </a>
              </li>
              <li>
                <a href="#mentors" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Mentores
                </a>
              </li>
              <li>
                <a href="#community" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Comunidad
                </a>
              </li>
              <li>
                <a href="#admissions" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Admisiones
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 text-sm hover:text-teal-400 transition-colors duration-200">
                  Careers
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/5 pt-8 mb-8">
          <p className="text-xs text-gray-500 leading-relaxed">
            <strong className="text-gray-400">Aviso Legal:</strong> Este sitio web es un prototipo demostrativo.
            Los perfiles de instructores, testimonios y nombres de empresas mostrados son representativos y ficticios,
            creados únicamente con fines de presentación. El contenido educativo real será impartido por emprendedores
            y ejecutivos verificados una vez el programa esté en funcionamiento.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-gray-500">
            © {currentYear} Urpe School of Liberty. Todos los derechos reservados.
          </p>
          <p className="text-sm text-gray-500">
            Powered by <span className="text-teal-400 font-semibold">Urpe AI Lab</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
